import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ModalService } from '@common/components/modal/modal.service';

@Injectable({providedIn: 'root', })
export class AppErrorHandler implements ErrorHandler {
    private modalService: ModalService;
    private modalShown: boolean = false;

    constructor(injector: Injector) {
        setTimeout(() => this.modalService = injector.get(ModalService));
    }
    handleError(error) {
		try {
			console.log(error);
			const message: string = (error.originalStack && error.originalStack.toString) ? error.originalStack.toString() : error.toString();
			const firstLine = message.split("\n")[0];
			let trace = null;
			if (window["sourceMappedStackTrace"] && window["sourceMappedStackTrace"].mapStackTrace) {
				window["sourceMappedStackTrace"].mapStackTrace(error.toString(), (mappedStack) => {
                    trace = null;
					if (mappedStack) {
						trace = mappedStack.join("\n");
					}
					if (!trace) {
						trace = error.toString();
					}
					if (this.modalService && !this.modalShown) {
						this.modalShown = true;
						this.modalService.openServiceFatalErrorModal({
							title: "Error",
							message: firstLine,
							detailedMessage: trace
						}, true).result.then((res) => {
                        }).finally(() => {
                            this.modalShown = false;
                        });
					}
				});
			} else {
                trace = this.getStackTrace(error);
				if (!trace) {
                    trace = error.toString();
				}
                // let modalShown = false;
				if (this.modalService && !this.modalShown) {
                    this.modalShown = true;
					this.modalService.openServiceFatalErrorModal({
						title: "Error",
						message: firstLine,
						detailedMessage: trace
					}, true).result.then((res) => {
	
					}).finally(() => {
                        this.modalShown = false;
                    });
				}
			}
		} catch (error) {
			
		}
    }
    
    getStackTrace(error) {
        try {
            (<any>Error).captureStackTrace(error);
            return error["stack"];
        } catch (err) {
            return null;
        }
    };
}
